import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.GmbMultiLocationMedia = routerStyxie({ actions: ['index', 'show', 'new']})
